import { http } from 'utils'
import { findIndex } from 'lodash'
import Vue from 'vue'

// Note state.
const state = {
  notes: []
}

// Note actions.
const actions = {
  /**
   * Get notes for a talent.
   *
   * @return Promise
   */
  getNotes ({ commit }, id) {
    return http.get(`user/${id}/notes`)
      .then((response) => {
        commit('SET_NOTES', response.data)

        return response
      })
  },

  /**
   * Store notes for a talent.
   *
   * @return Promise
   */
  storeNote ({ commit }, { id, payload }) {
    return http.post(`user/${id}/notes`, {
      text: payload.text,
      user_id: payload.user.id
    })
      .then((response) => {
        response.data.user = payload.user
        commit('ADD_NOTE', response.data)
        return response
      })
  },

  /**
   * Remove a note.
   *
   * @return Promise
   */
  removeNote ({ commit }, { id, noteId }) {
    return http.delete(`user/${id}/note/${noteId}`)
      .then((response) => {
        commit('REMOVE_NOTE', noteId)

        return response
      })
  },

  pinNote ({ commit }, { userId, noteId }) {
    return http.put(`user/${userId}/note/${noteId}/pin`)
      .then((response) => {
        commit('UNPIN_ALL_NOTES')
        commit('SET_NOTE', response.data)

        return response
      })
  }
}

// Note state mutations.
const mutations = {
  /**
   * Set notes
   */
  SET_NOTES (state, notes) {
    state.notes = notes
  },

  /**
   * Add new note
   */
  ADD_NOTE (state, note) {
    state.notes.unshift(note)
  },

  SET_NOTE (state, note) {
    const index = state.notes.findIndex(element => element.id === note.id)
    if (index !== -1) {
      state.notes.splice(index, 1, note)
    }
  },

  UNPIN_ALL_NOTES (state) {
    state.notes.forEach(note => {
      Vue.set(note, 'pinned', false)
    })
  },

  /**
   * Remove note
   */
  REMOVE_NOTE (state, id) {
    let index = findIndex(state.notes, note => note.id === id)

    state.notes.splice(index, 1)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, actions, mutations
}
